import './index.scss'
import React from 'react'

type SkeletonType = 'profile' | 'manage' | 'modalFromQr' | ''

interface SkeletonProps {
  type: SkeletonType
}

const Skeleton: React.FC<SkeletonProps> = ({ type }) => {

  const renderSkeleton = () => {
    switch (type) {
      case 'profile':
        return <div className='skeleton__profile'>
          <span className='bar'></span>
          <div className="skeleton__profile__image"></div>
          <div className="skeleton__profile__sentence"></div>
          <div className="skeleton__profile__buttons">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className="skeleton__profile__tabs">
            <div className="skeleton__profile__tabs__head">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div className="skeleton__profile__tabs__body"></div>
          </div>
        </div>
      case 'manage':
        return <div>Skeleton manage</div>
      case 'modalFromQr':
        return <div className='skeleton__modalFromQr'>
          <span></span>
          <div></div>
          <div></div>
          <div></div>
          </div>
      default:
        return <div>Default Skeleton</div>
    }
  }

  return (
    <div>
      {renderSkeleton()}
    </div>
  )
}

export default Skeleton
